module.exports = __webpack_public_path__ + "img/embaixo6.90256da8.jpg";